export default __webpack_public_path__ + "static/media/forgot-password-welcome.91915e8b.png";